import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'orderByAngular'
})
export class OrderByPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
